import { FileMetadata } from 'state';

/**
 * Given a sorted-by-date metadata array and the current video playback position
 * (in seconds since the start of the file), returns the metadata record whose
 * GPS timestamp is closest to that playback position.
 *
 * Uses binary search (O log n) so it is safe to call on every timeupdate event
 * regardless of how many metadata records exist.
 */
export const getMetadataAtTime = (
  metadata: FileMetadata[],
  fileProgress: number,
): FileMetadata | undefined => {
  if (!metadata || metadata.length === 0) return undefined;

  const startMs = new Date(metadata[0].date).getTime();
  const targetMs = startMs + fileProgress * 1000;

  let lo = 0;
  let hi = metadata.length - 1;

  while (lo < hi) {
    const mid = Math.floor((lo + hi) / 2);

    if (new Date(metadata[mid].date).getTime() < targetMs) {
      lo = mid + 1;
    } else {
      hi = mid;
    }
  }

  if (lo === 0) return metadata[0];

  const before = new Date(metadata[lo - 1].date).getTime();
  const after = new Date(metadata[lo].date).getTime();

  return targetMs - before <= after - targetMs ? metadata[lo - 1] : metadata[lo];
};
